var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",style:(_vm.theme),on:{"click":function($event){return _vm.back()}}},[_vm._v(_vm._s(_vm.label || 'Back'))])
}
var staticRenderFns = []

export { render, staticRenderFns }